import StudentTotalPoint from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'studentId':
    case 'totalPoint':
      return [key, `${val}`];
    default:
      return [key, val];
  }
};

const create = (data) => new StudentTotalPoint(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/OnlineHomework/TotalPoint/create.js